// extracted by mini-css-extract-plugin
module.exports = {"resultsGrid":"Results_resultsGrid__rC3XV","hasFade":"Results_hasFade__Uulu_","shimmer":"Results_shimmer__F_Cbi","shimmerKeyFrame":"Results_shimmerKeyFrame__gW2Jk"};